import { useSnapshot } from 'valtio';

import { pageLoadGlobalsState } from 'state/page-load-globals';

/**
 * The site-wide messages `_app` fetches once per server render. Everything
 * else on the `general` global is fetched by the feature that renders it,
 * through the hooks in `use-general-globals`.
 */
export const usePageLoadGlobals = () => {
    const { globals } = useSnapshot(pageLoadGlobalsState);

    return globals;
};
